export default {
      id: "icon-mobile-menu-phone-usage",
      viewBox: "0 0 17 16",
      url: "../icon/" + "icons.svg#icon-mobile-menu-phone-usage",
      toString: function () {
        return this.url;
      }
    }